import { post } from "@/shared/utils/fetchApi";

export interface SendEmailPayload {
  mode: "test" | "all-users";
  testEmail?: string;
  confirm?: boolean;
  subjectEn: string;
  subjectPt: string;
  bodyEn: string;
  bodyPt: string;
}

export interface SendEmailResponse {
  success: boolean;
  message: string;
  data?: { total?: number; en?: number | boolean; pt?: number | boolean };
}

export class EmailSenderService {
  static async send(payload: SendEmailPayload): Promise<SendEmailResponse> {
    // v2 responde flat (test 200 {en,pt} booleans; all-users 202 {total,en,pt}
    // counts) — sintetiza o envelope legacy {success, message, data} que o
    // componente consome (toast lê `message`).

    if (payload.mode === "test") {
      const raw = await post<{ en: boolean; pt: boolean }>(
        "/admin/email-sender/send",
        payload,
      );
      return {
        success: !!raw?.en && !!raw?.pt,
        message: `Test emails dispatched to ${payload.testEmail}`,
        data: raw,
      };
    }
    const raw = await post<{ total: number; en: number; pt: number }>(
      "/admin/email-sender/send",
      payload,
    );
    return {
      success: true,
      message: `Bulk send started for ${raw?.total ?? 0} recipients`,
      data: raw,
    };
  }
}
